export default __webpack_public_path__ + "static/media/star_filled.e7314dd0.svg";